<template>
    <div class="componentRoot">
        <v-card v-if="retreatData">
            <v-container fluid class="pa-0">
                <v-row>
                    <v-col style="position: relative;">
                        <FileInputCardVue :height="'30vh'" />

                        <WaveVue :color="'rgb(var(--v-theme-light))'" :inverted="false" :negative="true"
                            style="position:absolute; z-index: 5; bottom: 8px" />
                    </v-col>
                </v-row>
            </v-container>

            <v-container>
                <v-row>
                    <v-col class="pl-6">
                        <h1 class="overflow-ellipsis">
                            {{ retreatData.name }}
                            
                       ({{ retreatData.display_start_date }} - 
                       {{ retreatData.display_end_date }})
                        </h1>
                    </v-col>

                    <v-col cols="auto" v-if="$checkRouterPermission('PATCH')" class="pa-4 pr-10">
                        <v-tooltip :text="$t('basics.new', { type: $t('basics.retreat') })">
                            <template v-slot:activator="{ props }">
                                <div v-bind="props" @click="showEditRetreat($event)" flat><v-icon size="large"
                                        color="primary">mdi-pencil</v-icon></div>
                            </template>
                        </v-tooltip>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col >
                        <v-textarea variant="solo" rows="1" class="hideDetails" readonly auto-grow flat
                            v-model="retreatData.description"></v-textarea>
                    </v-col>
                </v-row>

                <v-row>
                    <v-col class="pl-8">
                        <h3>{{ $t("basics.participants") }}:</h3>
                    </v-col>
                </v-row>
                <v-row class="hoverable" v-for="user in retreatData.users" @click="gotoUser($event, user.user, false)"  @mousedown.middle="gotoUser($event, user.user, true)">
                    <v-col class="pl-8" cols="auto">
                            <v-tooltip :text="$t('constants.userToRetreatStatus_' + user.display_status)">
                <template v-slot:activator="{ props }">
                        <v-icon v-bind="props">{{ getIcon(user.display_status) }}</v-icon>
                </template>
                            </v-tooltip>
                    </v-col>
                    <v-col class="">
                    {{ user.user.full_name }}
                    </v-col>
                </v-row>
                
                <v-divider class="my-8" />

            </v-container>
        </v-card>

        <DeletionWarningVue :type="'retreat'" :additionalMessage="$t('messages.confirmDeletionItem', { item: retreatData?.name })
            " :refreshDisplay="deleteRetreatDrawer" @delete="deleteRetreat"
            style="z-index: 1007 !important" />

        <RetreatEditVue :refreshDisplay="editRetreatDrawer" @close="closeEditRetreat"
            :retreatData="retreatData" @delete="showDeleteRetreat"
            :readonly="!$checkRouterPermission('PATCH')" />


        <LoadingScreenVue :loading="loading" />
    </div>
</template>

<script>
import RetreatEditVue from '../../../components/products/RetreatEdit.vue';

export default {
    name: "retreatDetailComponent",

    props: [],

    data() {
        return {
            retreatData: undefined,

            loading: false,
            editRetreatDrawer: 0,

            deleteRetreatDrawer: 0
        };
    },

    computed: {
        isMobile() {
            switch (this.$vuetify.display.name) {
                case "xs":
                    return true;
                case "sm":
                    return true;
                case "md":
                    return false;
                case "lg":
                    return false;
                case "xl":
                    return false;
                case "xxl":
                    return false;
                default:
                    return false;
            }
        },
        searchBarCols() {
            switch (this.$vuetify.display.name) {
                case "xs":
                    return 12;
                case "sm":
                    return 6;
                case "md":
                    return 7;
                case "lg":
                    return 7;
                case "xl":
                    return 7;
                case "xxl":
                    return 6;
                default:
                    return 4;
            }
        },
    },

    components: {
        RetreatEditVue,
    },

    methods: {
        getIcon(displayStatus){
            switch(displayStatus){
                case "pending": return "mdi-clock-outline"
                case "accepted": return "mdi-check-all"
                case "denied": return "mdi-close"
                case "cancelled": return "mdi-cancel"
            }
        },
        gotoUser(event, user, newTab){
            event.stopPropagation()
            event.preventDefault()

            if(!this.$checkFunctionPermission(["user_detail"])){
                return
            }

            if(!user.readable){
                return
            }

            if(newTab){
                window.open("/backoffice/users/" + user.id + "/overview", "_blank")
            }
            else{
                this.$router.push("/backoffice/users/" + user.id + "/overview", "_blank")
            }
        },
        deleteRetreat() {
            this.loading = true;
            this.axios
                .patch(
                    this.axios.defaults.baseURL +
                    "media/retreats/delete/" +
                    this.retreatData.id,
                    {
                        deleted: true,
                    }
                )
                .then(() => {
                    this.loading = false;
                    this.deleteRetreatDrawer = 0;
                    this.editRetreatDrawer = 0;
                    this.fetchData();
                })
                .catch((e) => {
                    this.loading = false;
                    console.log(e);
                    window.dispatchEvent(new CustomEvent("showErrorDisplay", { detail: e }));
                });
        },
        showDeleteRetreat(retreat) {
            this.activeRetreat = retreat;
            this.deleteRetreatDrawer++;
        },
        showEditRetreat(event, retreat) {
            event.preventDefault();
            event.stopPropagation();

            this.activeRetreat = retreat;
            this.editRetreatDrawer++;
        },
        closeEditRetreat(data) {
            this.editRetreatDrawer = 0;

            if (data) {
                this.fetchData()
            }
        },
        fetchData() {
            this.loading = true
            this.axios.get(this.axios.defaults.baseURL + "media/retreats/" + this.$route.params.retreatID)
                .then((resp) => {
                    this.retreatData = resp.data
                    this.loading = false


                    this.$store.dispatch("setActiveElem", { retreatID: resp.data.name });
                })

                .catch((e) => {
                    this.loading = false
                    console.log(e);
                    window.dispatchEvent(new CustomEvent("showErrorDisplay", { detail: e }));
                });
        }
    },
    mounted() {
        this.fetchData();
    },
};
</script>
